import { Component, OnInit, Inject, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwSectionBaseComponent, DwComponentSectionPreference, DwComponentType, DwComponent, DwSelectLookupComponent, DwExpressionService, DwUiConfigRegistryService, DwUIMetaDataConfigToken, 
    DwUIMetaDataConfig, DwMetaDataServiceToken, DwMetaDataService, DwMessagingService, DwOrmDataServiceToken, DwOrmDataService, DwQueryHelper, DwSecuritySSOService, DwSecurityRepositoryServiceToken, 
    DwSecurityRepositoryService, DwSecurityUserService, DwQueryFilter, DwOperator, DwFilterType, DwMetaDataFilter, DwMetaDataFilterService, DwMetaDataFilters, DwMetaDataGridPreferences } from '@devwareapps/devware-cap';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { AppMetaDataService, AppMetaDataLookups } from 'src/app/meta-data/app-meta-data.service';

@DwComponent({
    name: 'TeamYearGrid',
    parentItemName: 'UserTeamLookup',
    componentType: DwComponentType.formSection,
  })
  
  @Component({
    selector: 'app-team-year-grid',
    templateUrl: 'team-year-grid.component.html'
  })
  export class TeamYearGrid extends DwSectionBaseComponent<DwComponentSectionPreference>
    implements OnInit {
  
    teamFilter: DwMetaDataFilter;
    yearFilter: DwMetaDataFilter;
    filterGroup: DwMetaDataFilters;
  
    // fileId: number;
    constructor(dwExpressionService: DwExpressionService,
      dwUiConfigRegistryService: DwUiConfigRegistryService,
      @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
      @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
      @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService) {
      super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    }
  
    ngOnInit() {
        
      //if (this.formGroup.get("TeamId") === null) { this.formGroup.addControl("TeamId", new FormControl())} ;
      super.ngOnInit();

      this.formGroup.valueChanges
        .pipe(map(formData => { return { teamId: formData.TeamId, fiscalYear: formData.FiscalYear }; }),

          debounceTime(10),
          distinctUntilChanged())
            .subscribe(data => {
              // clear the filter group each time so it triggers ngChanges on the grid component
              this.filterGroup = {};
  
              this.teamFilter = { EQUAL: data.teamId };
              this.filterGroup["WachterTeamId"] = this.teamFilter;

              this.yearFilter = {EQUAL: data.fiscalYear };
              this.filterGroup["FiscalYear"] = this.yearFilter;
            });
            
            /*this.formGroup.get("TeamId").valueChanges.subscribe(x => {
                this.teamFilter = { EQUAL: this.formGroup.get("TeamId").value };
                this.filterGroup["WachterTeamId"] = this.teamFilter;
            })
            this.formGroup.get("FiscalYear").valueChanges.subscribe(x => {
                this.yearFilter = {EQUAL: this.formGroup.get("FiscalYear").value };
                this.filterGroup["FiscalYear"] = this.yearFilter;
            })*/
    }


  
  }
  